module.exports = __webpack_public_path__ + "static/img/bill_huang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/bill_huang.jpg
// module id = nz6S
// module chunks = 0